module.exports = {
  DashboardPortfolioComponentEvents: {
    DashboardPortfolio: {
      code: 'DashboardPortfolio',
      events: {
        Loaded: {
          description: 'Triggers when the portfolio tab is loaded.',
          eventHub: {
            code: 'DashboardPortfolio',
            action: 'DashboardPortfolio_Loaded'
          }
        },
        StartContributingClicked: {
          description: 'Triggers on click of Start contributing CTA',
          eventHub: {
            code: 'DashboardPortfolio',
            action: 'DashboardPortfolio_StartContributing_Clicked'
          }
        },
        IncomeModalClicked: {
          description: 'Triggers on click of Income modal.',
          eventHub: {
            code: 'DashboardPortfolio',
            action: 'DashboardPortfolio_IncomeModal_Clicked'
          }
        },
        ViewAssetCTAClicked: {
          description: 'Triggers on click of View asset mix CTA.',
          eventHub: {
            code: 'DashboardPortfolio',
            action: 'DashboardPortfolio_ViewAsset_CTAClicked'
          },
          ga: {
            action: 'DashboardPortfolio_ViewAsset_CTAClicked'
          }
        },
        AssetMixLoaded: {
          description: 'Triggers when the asset mix page is loaded.',
          eventHub: {
            code: 'DashboardPortfolio',
            action: 'DashboardPortfolio_AssetMix_Loaded'
          },
          ga: {
            action: 'DashboardPortfolio_AssetMix_Loaded'
          }
        }
      }
    }
  }
};
